export class NewLocationWizardRequest {
  LocationName: string = '';
  ParentLocationID: number = -1;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
